export { default } from './Img'
